export const EAppLanding = {
	topInfo: 'landingAppTopInfo',
	heroInfo: 'landingAppHeroInfo',
	iconInfo: 'landingAppIconInfo',
	safetyInfo: 'landingAppSafetyInfo',
	updatedInfo: 'landingAppUpdatedInfo',
	screensInfo: 'landingAppScreensInfo',
	appInfo: 'landingAppInfo',
	ratingSettings: 'landingAppRatingSettings',
}